import { ArdoqId } from '@ardoq/api-types';
import { PermissionContext } from '../types';
import { canDo } from '../canDo';
import { permissionsOperations } from '../permissionsOperations';

export const canEditReport = ({
  permissionContext,
  reportId,
}: {
  permissionContext: PermissionContext;
  reportId: ArdoqId;
}): boolean =>
  canDo({
    action: 'report/edit',
    permissionContext,
    resourceId: reportId,
  });

export const canAccessReport = ({
  permissionContext,
  reportId,
}: {
  permissionContext: PermissionContext;
  reportId: ArdoqId;
}): boolean =>
  canDo({
    action: 'report/read',
    permissionContext,
    resourceId: reportId,
  });

export const canCreateReport = (
  permissionContext: PermissionContext
): boolean => {
  if (!permissionsOperations.isLoadedPermissionContext(permissionContext)) {
    return false;
  }

  return permissionsOperations.isOrgWriter(permissionContext.user);
};

export const canAdminReport = ({
  permissionContext,
  reportId,
}: {
  permissionContext: PermissionContext;
  reportId: ArdoqId;
}): boolean =>
  canDo({
    action: 'report/admin',
    permissionContext,
    resourceId: reportId,
  });
